import { zodContract } from '@farfetched/zod';
import { createPlatformMutation } from '../clients';
import { logoutResponseSchema } from '../types';

export const logoutMutation = createPlatformMutation({
	request: {
		method: 'DELETE',
		url: '/logout',
	},
	response: {
		contract: zodContract(logoutResponseSchema),
	},
});
